<template>
  <div class="booking-view">
    <div class="booking-view__header">
      <order-progress :step="3"></order-progress>
      <hotel-block-header
        v-if="hotelData"
        :class="{
        'hotel-block-header--agency': true,
        'hotel-block--loading': hotelLoading,
        }"
        :agency="true"
        :hotel="hotel"
        @goback="goBack"
      ></hotel-block-header>
    </div>
    <div class="booking-view__body">
      <booking-messages
        :loadingOffer="loadingOffer"
        :loadingError="loadingError"
        :isNKOffer="isNKOffer"
        :bookingError="makeBookingerror"
        :bookingState="makeBookingState"
        :adminWarning="showAdminWarning"
        :changeList="changeList"
        :inEditMode="inEditMode"
        @goback="goBack"
      ></booking-messages>
      <div class="booking-view__body__flex">
        <booking-travel
          v-if="showBookingFields"
          :offer-data="offerData"
        ></booking-travel>
        <booking-form
          :ready="showBookingFields"
          :changeList="changeList"
          @editmode="(val) => inEditMode = val"
          @dobooking="doBooking"
          @userConsentedPrice="setUserConsentPrice"
          ref="bookingform"
        ></booking-form>
      </div>
    </div>
  </div>
</template>

<script>
import OrderProgress from "../components/order-progress.vue";
import HotelBlockHeader from "../components/hotel-block/hotel-block-header.vue";
import BookingTravel from "../components/booking-travel.vue";
import BookingForm from "../components/booking-form.vue";
import BookingMessages from "./../components/booking/booking-messages.vue";
import Moment from "moment";
import currencyFormatter from "currency-formatter";
import * as Sentry from "@sentry/vue";

import _ from "underscore";
import { scrollTo } from 'scroll-js';

let CheckInterval = null;

export default {
  data() {
    return {
      changes: {},
      hotelLoading: false,
      loadingOffer: false,
      loadingError: null,
      translations: APP_CONFIG.TRANSLATION.BOOKING,
      makeBookingState: null,
      makeBookingerror: null,
      hasNKStatus: false,
      showAdminWarning: false,
      doingBooking: false,
      ignoreOfferStatus: false,
      inEditMode: true,
      userConsentPrice: null,
      currencyOptions: {
        thousand: ".",
        decimal: ",",
        precision: 0,
        format: "%v",
      },
    };
  },
  mounted() {
    this.getOffer().then(() => {
      this.startOfferCheckInterval();
      window.addEventListener('focus', this.onActiveWindow);
      window.addEventListener('blur', this.stopOfferCheckInterval);
    });

    this.$store.dispatch("getCountries");
  },
  beforeDestroy() {
    this.$store.commit('selectedBookingOffer', {});
    this.$store.commit('selectedAgencyOffer', {});
    window.removeEventListener('focus', this.onActiveWindow);
    window.removeEventListener('blur', this.stopOfferCheckInterval);
    this.stopOfferCheckInterval();
  },
  methods: {
    onActiveWindow() {
      console.log('Active window');
      this.updateAndCheckOfferForChanges().then(() => {
        this.startOfferCheckInterval();
      }).catch((err) => {
        console.error(err);
      })
    },
    startOfferCheckInterval() {
      if (!CheckInterval && !this.isNKOffer) {
        console.log('Start offer check interval');
        CheckInterval = setInterval(() => {
          this.updateAndCheckOfferForChanges();
        }, 30000);
      }
    },
    stopOfferCheckInterval() {
      if (CheckInterval) {
        console.log('Stop offer check interval');
        clearInterval(CheckInterval);
        CheckInterval = null;
      }
    },
    updateAndCheckOfferForChanges() {
      return this.loadBookingDraft().then(() => {
        if (this.isNKOffer) {
          this.stopOfferCheckInterval();
        } else {
          this.cehckInitialPriceChange();
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    cehckInitialPriceChange() {
      const selectedBookingOffer = this.$store.state.selectedBookingOffer;
      if (this.offer && selectedBookingOffer.priceChanged) {
        this.$nextTick(() => {
          this.$set(this.changes, "price", {
            old: selectedBookingOffer.priceChanged.oldTotalPrice,
            new: selectedBookingOffer.priceChanged.newTotalPrice,
          });
        })
      }
    },
    checkChangesFromOriginal() {
      let original = this.$store.state.selectedAgencyOffer;
      let draftoffer = _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "packageOffer",
      ]);

      //Check if initial price has changed and show the chagne
      this.cehckInitialPriceChange();

      if (draftoffer && original) {
        let originalOutboundLeglist = _.propertyOf(original)([
          "flightOffer",
          "flight",
          "outboundLegList",
        ]);
        let draftOutboundLeglist = _.propertyOf(draftoffer)([
          "flightOffer",
          "flight",
          "outboundLegList",
        ]);

        if (originalOutboundLeglist && draftOutboundLeglist) {
          //departureDate
          let originalDepartureDate = _.propertyOf(originalOutboundLeglist)([
            0,
            "departureDateTime",
          ]);
          let draftDepartureDate = _.propertyOf(draftOutboundLeglist)([
            0,
            "departureDateTime",
          ]);
          if (
            originalDepartureDate &&
            draftDepartureDate &&
            originalDepartureDate != draftDepartureDate
          ) {
            this.$set(this.changes, "departureDate", {
              old: originalDepartureDate
                ? Moment(originalDepartureDate).format("DD/MM/YYYY HH:mm")
                : "",
              new: draftDepartureDate
                ? Moment(draftDepartureDate).format("DD/MM/YYYY HH:mm")
                : "",
            });
          }

          //inboundStops
          let originalStops = originalOutboundLeglist.length - 1;
          let draftStops = draftOutboundLeglist.length - 1;
          if (originalStops != draftStops) {
            this.$set(this.changes, "outboundStops", {
              old: originalStops > 0 ? originalStops : 0,
              new: draftStops > 0 ? draftStops : 0,
            });
          }

          if (!_.isEqual(originalOutboundLeglist, draftOutboundLeglist)) {
            this.$set(this.changes, "outboundFlight", {
              old: originalOutboundLeglist,
              new: draftOutboundLeglist,
            });
          }
        }

        let originalInboundLegList = _.propertyOf(original)([
          "flightOffer",
          "flight",
          "inboundLegList",
        ]);
        let draftInbountLegList = _.propertyOf(draftoffer)([
          "flightOffer",
          "flight",
          "inboundLegList",
        ]);

        if (originalInboundLegList && draftInbountLegList) {
          //homeAgainDate
          let orignalHomeLeg = _.last(originalInboundLegList);
          let draftHomeLeg = _.last(draftInbountLegList);

          let originalArrivalTime =
            _.propertyOf(orignalHomeLeg)("arrivalDateTime");
          let draftArrivalTime = _.propertyOf(draftHomeLeg)("arrivalDateTime");

          if (
            originalArrivalTime &&
            draftArrivalTime &&
            originalArrivalTime != draftArrivalTime
          ) {
            this.$set(this.changes, "homeAgainDate", {
              old: originalArrivalTime
                ? Moment(originalArrivalTime).format("DD/MM/YYYY HH:mm")
                : "",
              new: draftArrivalTime
                ? Moment(draftArrivalTime).format("DD/MM/YYYY HH:mm")
                : "",
            });
          }

          //inboundStops
          let originalStops = originalInboundLegList.length - 1;
          let draftStops = draftInbountLegList.length - 1;
          if (originalStops !== draftStops) {
            this.$set(this.changes, "inboundStops", {
              old: originalStops > 0 ? originalStops : 0,
              new: draftStops > 0 ? draftStops : 0,
            });
          }

          if (!_.isEqual(originalInboundLegList, draftInbountLegList)) {
            this.$set(this.changes, "inboundFlight", {
              old: originalInboundLegList,
              new: draftInbountLegList,
            });
          }
        }
      }
    },
    doBooking(bookingData) {
      if (this.doingBooking) {
        return;
      }

      this.stopOfferCheckInterval();
      this.makeBookingState = this.translations.BOOKING_STATES.updating_draft;
      this.makeBookingerror = null;
      this.showAdminWarning = false;
      let params = Object.assign({}, bookingData);
      console.log("Params posted", params);
      scrollTo(document.body, { top: 0 });

      try {
        let packageOffer =
          this.$store.state.selectedBookingOffer.verifiedOffer.packageOffer;
        params.totalPriceEuro = packageOffer.totalPriceEuro;
        params.totalPrice = packageOffer.totalPrice;
        let oldChanges = Object.assign({}, this.changes);
        console.log("Old cahnges", oldChanges);

        this.doingBooking = true;
        this.ignoreOfferStatus = true;

        this.$store
          .dispatch("updateBookingDraft", {
            draftId: this.$route.params.draftid,
            params,
          })
          .then(() => {
            console.log("New changes", this.changes);
            this.cehckInitialPriceChange();
            this.$nextTick(() => {
              if (!_.isEqual(oldChanges, this.changes)) {
                this.makeBookingState = null;
                this.doingBooking = false;
                this.ignoreOfferStatus = false;
                this.$nextTick(() => {
                  this.startOfferCheckInterval();
                  if (this.$refs.bookingform) {
                    this.$refs.bookingform.gotoEditMode();
                  }
                });
              } else {
                this.makeBookingState =
                  this.translations.BOOKING_STATES.doing_booking.replace(/\{operator_name\}/, this.offerData.tourOperator);
                this.$store
                  .dispatch("makeBooking", this.$route.params.draftid)
                  .then((response) => {
                    this.doingBooking = false;
                    if (response.status === "ADMIN_REQUIRED") {
                      this.showAdminWarning = true;
                      this.makeBookingerror = null;
                      this.makeBookingState = null;
                    } else {
                      this.$router.push({
                        path: "/booking/" + this.$route.params.draftid + "/order",
                      });
                    }
                  })
                  .catch((error) => {
                    this.doingBooking = false;
                    this.ignoreOfferStatus = false;
                    console.error(error);
                    if (error === "XX" || error === "NK") {
                      this.hasNKStatus = true;
                      this.makeBookingerror = null;
                      this.makeBookingState = null;
                    } else {
                      this.makeBookingState = null;
                      this.makeBookingerror =
                        this.translations.ERRORS.booking_error;
                    }
                  });
              }
            });
          })
          .catch((error) => {
            console.error(error);
            this.makeBookingState = null;
            this.makeBookingerror = this.translations.ERRORS.booking_error;
            this.doingBooking = false;
            this.ignoreOfferStatus = false;
          });
      } catch (e) {
        console.error(e);
        this.makeBookingerror = this.translations.ERRORS.booking_error;
        this.doingBooking = false;
        this.ignoreOfferStatus = false;
        Sentry.captureException(e, {
          extra: { params: JSON.stringify(params) },
          tags: {
            makeBooking: true,
            draftId: this.draftId
          }
        });
      }
    },
    setUserConsentPrice() {
      this.userConsentPrice = Object.assign({}, this.price);
    },
    getOffer() {
      let draftId = this.draftId;
      if (draftId) {
        Sentry.setTag('draftId', draftId);

        //Checking if current draft ID is already loaded
        if (draftId == this.$store.state.selectedBookingOffer.draftId) {
          this.checkChangesFromOriginal();
          return Promise.resolve();
        }

        this.loadingError = null;
        this.loadingOffer = true;

        return this.loadBookingDraft().then(() => {
          this.loadingOffer = false;
          this.checkChangesFromOriginal();
        }).catch((error) => {
          this.loadingOffer = false;
          this.loadingError = this.translations.ERRORS.no_offer;
        })
      }
    },
    loadBookingDraft() {
      let draftId = this.draftId;
      if (!draftId) {
        return Promise.reject();
      }

      return this.$store
        .dispatch("loadBookingDraft", draftId);
    },
    goBack() {
      this.$router.back();
    },
  },
  watch: {
    "$route.params.draftid"() {
      this.stopOfferCheckInterval();
      this.getOffer().then(() => {
        this.startOfferCheckInterval();
      });
    },
    departureDate(newVal, oldVal) {
      if (newVal && oldVal) {
        this.$set(this.changes, "departureDate", {
          new: newVal,
          old: oldVal,
        });
      }
    },
    homeAgainDate(newVal, oldVal) {
      if (newVal && oldVal) {
        this.$set(this.changes, "homeAgainDate", {
          new: newVal,
          old: oldVal,
        });
      }
    },
    inboundStops(newVal, oldVal) {
      if (typeof oldVal === "number" && typeof newVal === "number") {
        this.$set(this.changes, "inboundStops", {
          new: newVal,
          old: oldVal,
        });
      }
    },
    outboundStops(newVal, oldVal) {
      if (typeof oldVal === "number" && typeof newVal === "number") {
        this.$set(this.changes, "outboundStops", {
          new: newVal,
          old: oldVal,
        });
      }
    },
    outboundFlight: {
      handler(newVal, oldVal) {
        if (oldVal && newVal && !_.isEqual(newVal, oldVal)) {
          this.$set(this.changes, "outboundFlight", {
            new: newVal,
            old: oldVal,
          });
        }
      },
      deep: true,
    },
    inboundFlight: {
      handler(newVal, oldVal) {
        if (oldVal && newVal && !_.isEqual(newVal, oldVal)) {
          this.$set(this.changes, "inboundFlight", {
            new: newVal,
            old: oldVal,
          });
        }
      },
      deep: true,
    },
  },
  computed: {
    draftId() {
      return this.$route.params.draftid;
    },
    showBookingFields() {
      return this.offer &&
        !this.loadingError &&
        !this.makeBookingState &&
        !this.makeBookingerror &&
        !this.showAdminWarning
        ? true
        : false;
    },
    isNKOffer() {
      //If user have initiated the booking process, we don't check the statuscode of the verified offer
      if(this.ignoreOfferStatus) {
        return false;
      }

      let offer = this.$store.state.selectedBookingOffer.verifiedOffer;
      return (offer && (offer.status === "NK" || offer.status === "XX")) || this.hasNKStatus
        ? true
        : false;
    },
    offer() {
      let offer = this.$store.state.selectedBookingOffer.verifiedOffer;
      if (offer && offer.packageOffer) {
        return offer;
      }

      return null;
    },
    offerData() {
      if (
        !this.offer ||
        this.loadingOffer ||
        this.loadingError ||
        this.isNKOffer
      ) {
        return {};
      }

      let originalRoomName = [];
      let translatedRoomName = [];
      if (this.offer.packageOffer.hotelOffer) {
        const roomType = this.offer.packageOffer.hotelOffer.roomType;

        originalRoomName.push(roomType.name);
        if (roomType.additionalRoomName) {
          originalRoomName.push(roomType.additionalRoomName);
        }

        if (roomType.translatedAdditionalRoomName) {
          translatedRoomName.push(roomType.name);
          translatedRoomName.push(roomType.translatedAdditionalRoomName);
        }
      }

      try {
        return {
          tourOperatorCode: this.offer.packageOffer.tourOperator
            ? this.offer.packageOffer.tourOperator.code
            : null,
          tourOperator: this.offer.packageOffer.tourOperator.name || "",
          transferInlcuded:
            this.offer.packageOffer.transferIncluded === true ? true : false,
          originalRoomName,
          translatedRoomName,
          boardType: this.offer.packageOffer.hotelOffer
            ? this.offer.packageOffer.hotelOffer.boardType.name
            : null,
          totalPrice: this.offer.packageOffer.totalPrice,
          verified: this.offer.status ? true : false,
          status: this.offer.status,
          travelDate: this.offer.packageOffer
            ? this.offer.packageOffer.travelDate
            : null,
          handicap: this.offer.bookingInformation
            ? this.offer.bookingInformation.accommodatesDisabledGuests
            : false,
          hasFlightOffer: this.offer.packageOffer.flightOffer ? true : false,
          inboundFlight: {
            estimatedTime: this.offer.packageOffer.flightOffer
              ? this.offer.packageOffer.flightOffer.flight
                .inboundEstimatedTravelTime
              : null,
            legList: this.offer.packageOffer.flightOffer
              ? this.offer.packageOffer.flightOffer.flight.inboundLegList
              : null,
          },
          outboundFlight: {
            estimatedTime: this.offer.packageOffer.flightOffer
              ? this.offer.packageOffer.flightOffer.flight
                .outboundEstimatedTravelTime
              : null,
            legList: this.offer.packageOffer.flightOffer
              ? this.offer.packageOffer.flightOffer.flight.outboundLegList
              : null,
          },
        };
      } catch (e) {
        return {};
      }
    },
    price() {
      return this.offerData.totalPrice;
    },
    departureDate() {
      if (this.offerData.outboundFlight) {
        return Moment(
          this.offerData.outboundFlight.legList[0].departureDateTime
        ).format("DD/MM/YYYY HH:mm");
      }

      return "";
    },
    homeAgainDate() {
      if (this.offerData.inboundFlight) {
        let list = this.offerData.inboundFlight.legList;
        return Moment(list[list.length - 1].arrivalDateTime).format(
          "DD/MM/YYYY HH:mm"
        );
      }

      return "";
    },
    inboundStops() {
      if (this.offerData.inboundFlight) {
        let numberOfStops = this.offerData.inboundFlight.legList.length - 1;
        return numberOfStops > 0 ? numberOfStops : 0;
      }
    },
    outboundStops() {
      if (this.offerData.outboundFlight) {
        let numberOfStops = this.offerData.outboundFlight.legList.length - 1;
        return numberOfStops > 0 ? numberOfStops : 0;
      }
    },
    outboundFlight() {
      if (this.offerData.outboundFlight) {
        return this.offerData.outboundFlight;
      }

      return null;
    },
    inboundFlight() {
      if (this.offerData.inboundFlight) {
        return this.offerData.inboundFlight;
      }

      return null;
    },
    hotelData() {
      let selectedBookingOffer = this.offer;
      if (
        selectedBookingOffer &&
        selectedBookingOffer.packageOffer.hotelOffer &&
        selectedBookingOffer.packageOffer.hotelOffer.hotel
      ) {
        return selectedBookingOffer.packageOffer.hotelOffer.hotel;
      }

      return null;
    },
    hotel() {
      if (this.hotelData) {
        return {
          id: this.hotelData.id,
          title: this.hotelData.name,
          location: this.hotelData.location.name,
          rating: this.hotelData.rating,
          stars: this.hotelData.category,
        };
      }

      return {};
    },
    changeList() {
      let changes = [];
      if (!_.isEmpty(this.changes)) {
        for (let i in this.changes) {
          let str = null;
          switch (i) {
            case "price":
              let oldPrice = (this.changes[i].old) ? currencyFormatter.format(
                this.changes[i].old.value,
                this.currencyOptions
              ) : '';

              let newPrice = currencyFormatter.format(
                this.changes[i].new.value,
                this.currencyOptions
              );

              if (oldPrice) {
                str = this.translations.change_note_price_txt
                  .replace(/{{ old_price }}/, oldPrice)
                  .replace(/{{ new_price }}/, newPrice);
              } else {
                str = this.translations.change_note_only_new_price_txt
                  .replace(/{{ new_price }}/, newPrice);
              }

              break;
            case "departureDate":
              let departureDate_oldDate = this.changes[i].old;
              let departureDate_newDate = this.changes[i].new;
              str = this.translations.departure_date_change
                .replace(/{{ old_date }}/, departureDate_oldDate)
                .replace(/{{ new_date }}/, departureDate_newDate);
              break;
            case "homeAgainDate":
              let homeAgainDate_oldDate = this.changes[i].old;
              let homeAgainDate_newDate = this.changes[i].new;
              str = this.translations.arrival_date_change
                .replace(/{{ old_date }}/, homeAgainDate_oldDate)
                .replace(/{{ new_date }}/, homeAgainDate_newDate);
              break;
            case "inboundStops":
              let inboundStops_oldStops = this.changes[i].old;
              let inboundStops_newStops = this.changes[i].new;
              str = this.translations.flightstop_change_inbound
                .replace(/{{ old_stops }}/, inboundStops_oldStops)
                .replace(/{{ new_stops }}/, inboundStops_newStops);
              break;
            case "outboundStops":
              let outboundStops_oldStops = this.changes[i].old;
              let outboundStops_newStops = this.changes[i].new;
              str = this.translations.flightstop_change_outbound
                .replace(/{{ old_stops }}/, outboundStops_oldStops)
                .replace(/{{ new_stops }}/, outboundStops_newStops);
              break;
            case "outboundFlight":
              str = this.translations.flight_time_change_outbound;
              break;
            case "inboundFlight":
              str = this.translations.flight_time_change_inbound;
              break;
          }

          if (str) {
            changes.push({
              text: str,
              type: i
            });
          }
        }
      }

      return changes;
    },
  },
  components: {
    OrderProgress,
    HotelBlockHeader,
    BookingTravel,
    BookingForm,
    BookingMessages,
  },
};
</script>
